jQuery.fn.extend({
    isEmpty: function() {
        let value = this.val();
        return value === undefined || value === null || value === '';
    }
});
